/**
 * A controller to enable dialog components to access an options object
 */
export class DialogController {
  public static $inject = ['options', 'dialogClass', 'dialogTitle', 'content', '$mdDialog'];
  public showDialogSpinner: boolean;
  public searchText: string;

  constructor(
    public options: Object,
    public dialogClass: string,
    public dialogTitle: string,
    public content: string,
    private $mdDialog: ng.material.IDialogService
  ) { }

  /**
   * Closes the dialog
   * @param response the data sent from the dialog content
   */
  public closeDialog = (response?: any) => {
    this.$mdDialog.hide(response);
  }

  /**
   * Copies text to the clipboard
   */
  public copyToClipboard = () => {
    var copyText: any = document.getElementById("text-to-copy");

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    document.execCommand("copy");
  }

  /**
   * Cancels the dialog, reverting the action
   */
  public cancel = () => {
    this.$mdDialog.cancel();
  }
}
